export interface FanWork {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  chapters: number;
  words: number;
  heat: number;
  status: string;
  cover: string;
  desc: string;
}

export interface CharacterItem {
  id: string;
  name: string;
  epithet: string;
  count: number;
  cover: string;
  desc: string;
}

export interface CpItem {
  id: string;
  name: string;
  desc: string;
  count: number;
  tag: string;
}

export interface GenreItem {
  id: string;
  name: string;
  count: number;
  desc: string;
}

export interface LatestItem {
  id: string;
  title: string;
  category: string;
  author: string;
  date: string;
  heat: number;
  tag: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const heroCategoryChips = [
  "宇智波佐助",
  "漩涡鸣人",
  "卡卡西",
  "宇智波鼬",
  "佐鸣",
  "鼬佐",
  "HE甜文",
  "战斗热血",
];

export const navLinks = [
  { key: "featured", label: "热门推荐" },
  { key: "character", label: "角色合集" },
  { key: "cp", label: "CP专题" },
  { key: "genre", label: "题材分类" },
  { key: "latest", label: "最新更新" },
  { key: "faq", label: "常见问题" },
];

export const categoryNav = [
  {
    id: "featured",
    label: "热门推荐",
    desc: "站内人气最高、好评最多的同人合集",
    icon: "ri-fire-fill",
    color: "bg-primary-500",
  },
  {
    id: "character",
    label: "角色合集",
    desc: "围绕主要角色的同人作品专题",
    icon: "ri-user-star-fill",
    color: "bg-accent-500",
  },
  {
    id: "cp",
    label: "CP专题",
    desc: "人气CP与感情线同人导航",
    icon: "ri-heart-3-fill",
    color: "bg-secondary-500",
  },
  {
    id: "genre",
    label: "题材分类",
    desc: "长篇短篇、甜虐热血等题材整理",
    icon: "ri-quill-pen-fill",
    color: "bg-primary-700",
  },
];

export const featuredWorks: FanWork[] = [
  {
    id: "w1",
    title: "《第七班的日常》",
    author: "木叶的青鸟",
    category: "日常治愈",
    tags: ["鸣佐", "第七班", "治愈", "HE"],
    chapters: 46,
    words: 42,
    heat: 98600,
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20team%20of%20young%20ninjas%20sharing%20ramen%20at%20a%20warm%20wooden%20stall%20under%20twilight%20orange%20sky%2C%20cozy%20slice%20of%20life%20atmosphere%2C%20warm%20orange%20and%20dark%20ink%20tones%2C%20soft%20glow%2C%20cinematic%20lighting%2C%20detailed%20anime%20art&width=640&height=860&seq=cover-w1&orientation=portrait",
    desc: "跟随第七班在木叶村的平凡日常，任务之余一起嗦拉面、修练忍术，温暖治愈的成长故事。",
  },
  {
    id: "w2",
    title: "《写轮眼的倒影》",
    author: "彼岸之花",
    category: "深情羁绊",
    tags: ["鼬佐", "兄弟", "刀尖", "BE"],
    chapters: 32,
    words: 38,
    heat: 87200,
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=moody%20anime%20illustration%20of%20a%20lone%20ninja%20in%20dark%20robe%20standing%20in%20moonlight%2C%20red%20glowing%20eyes%2C%20falling%20cherry%20blossom%20petals%2C%20melancholic%20and%20emotional%2C%20dark%20red%20and%20black%20palette%2C%20dramatic%20anime%20art&width=640&height=860&seq=cover-w2&orientation=portrait",
    desc: "以宇智波兄弟的视角，重写那场命运的对决。写轮眼映出的，究竟是谁的倒影与思念。",
  },
  {
    id: "w3",
    title: "《风影的风》",
    author: "砂之守鹤",
    category: "热血成长",
    tags: ["我爱罗", "风影", "成长", "热血"],
    chapters: 58,
    words: 66,
    heat: 76000,
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=epic%20anime%20illustration%20of%20a%20young%20kage%20standing%20on%20a%20dune%20overlooking%20a%20desert%20village%2C%20sand%20storm%20swirling%2C%20determined%20pose%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20dynamic%20energy%2C%20high%20detail%20anime%20art&width=640&height=860&seq=cover-w3&orientation=portrait",
    desc: "从孤独的怪物到守护村子的风影，我爱罗如何在黄沙与人心之间，找到属于他的风。",
  },
  {
    id: "w4",
    title: "《木叶白牙之上》",
    author: "寒刃",
    category: "历史长篇",
    tags: ["旗木一族", "白牙", "长篇", "正剧"],
    chapters: 74,
    words: 88,
    heat: 69100,
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20silver%20haired%20shinobi%20wielding%20a%20white%20chakra%20blade%20under%20stormy%20sky%2C%20battle%20pose%2C%20dark%20clouds%2C%20steel%20blue%20and%20dark%20ink%20tones%20with%20orange%20flame%20accents%2C%20dramatic%20anime%20art&width=640&height=860&seq=cover-w4&orientation=portrait",
    desc: "回溯旗木白牙的传说，揭开木叶旧时代的一角。刀光剑影之间，是英雄与孤独的宿命。",
  },
  {
    id: "w5",
    title: "《佩恩与雨》",
    author: "晓的旗帜",
    category: "冷门佳作",
    tags: ["佩恩", "雨隐村", "哲学", "冷门"],
    chapters: 21,
    words: 26,
    heat: 53800,
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=rainy%20anime%20illustration%20of%20a%20tall%20figure%20in%20dark%20cloak%20with%20red%20clouds%20pattern%20standing%20in%20the%20rain%2C%20somber%20blue%20grey%20rain%20streaks%2C%20lone%20village%20lights%2C%20philosophical%20melancholy%2C%20dark%20and%20atmospheric%20anime%20art&width=640&height=860&seq=cover-w5&orientation=portrait",
    desc: "在永不停歇的雨里，佩恩看见了怎样的世界？一段关于和平、痛苦与信念的冷门深思。",
  },
  {
    id: "w6",
    title: "《樱花盛开的季节》",
    author: "春野的花信",
    category: "甜文HE",
    tags: ["鸣樱", "甜文", "HE", "轻松"],
    chapters: 18,
    words: 19,
    heat: 61200,
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=bright%20anime%20illustration%20of%20pink%20cherry%20blossom%20petals%20falling%20over%20a%20cheerful%20ninja%20couple%20on%20a%20hill%2C%20spring%20festival%20mood%2C%20soft%20pink%20and%20warm%20orange%20tones%2C%20joyful%20and%20sweet%2C%20detailed%20anime%20art&width=640&height=860&seq=cover-w6&orientation=portrait",
    desc: "当木叶的樱花再次盛开，那些没说出口的心意终于有了回响。轻松治愈的甜文日常。",
  },
];

export const characters: CharacterItem[] = [
  {
    id: "c1",
    name: "漩涡鸣人",
    epithet: "第七代火影",
    count: 186,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20blond%20spiky%20haired%20ninja%20with%20whisker%20marks%2C%20bright%20orange%20jacket%2C%20confident%20smile%2C%20whirling%20uzumaki%20spiral%20background%20in%20orange%20and%20black%2C%20vibrant%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-naruto&orientation=squarish",
    desc: "从吊车尾到火影的成长轨迹，人气主角的万千同人。",
  },
  {
    id: "c2",
    name: "宇智波佐助",
    epithet: "复仇者",
    count: 152,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20black%20haired%20ninja%20with%20dark%20eyes%20and%20cool%20expression%2C%20blue%20and%20black%20outfit%2C%20crimson%20lightning%20and%20red%20glow%20background%2C%20mysterious%20and%20intense%2C%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-sasuke&orientation=squarish",
    desc: "背负灭族与复仇的宇智波少年，爱与恨的交织。",
  },
  {
    id: "c3",
    name: "旗木卡卡西",
    epithet: "复制忍者",
    count: 98,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20silver%20haired%20ninja%20with%20a%20mask%20covering%20half%20his%20face%2C%20relaxed%20lazy%20pose%20reading%20a%20small%20book%2C%20dark%20forest%20background%2C%20muted%20tones%20with%20warm%20accents%2C%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-kakashi&orientation=squarish",
    desc: "懒散外表下的冷静与温柔，第七班的老师。",
  },
  {
    id: "c4",
    name: "宇智波鼬",
    epithet: "晓之叛忍",
    count: 87,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20long%20black%20haired%20ninja%20with%20a%20mole%20under%20eye%20and%20red%20sharingan%20eyes%2C%20dark%20cloak%20with%20red%20clouds%2C%20crows%20flying%20in%20moonlit%20sky%2C%20tragic%20and%20noble%2C%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-itachi&orientation=squarish",
    desc: "守护与牺牲的化身，鼬的所有温柔与决绝。",
  },
  {
    id: "c5",
    name: "我爱罗",
    epithet: "第五代风影",
    count: 62,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20young%20man%20with%20red%20hair%20and%20dark%20eyeliner%20holding%20a%20gourd%2C%20sand%20and%20gourd%20motifs%2C%20warm%20amber%20and%20brown%20desert%20background%2C%20calm%20and%20powerful%2C%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-gaara&orientation=squarish",
    desc: "从砂之怪物到守护村子的风影，成长的经典。",
  },
  {
    id: "c6",
    name: "春野樱",
    epithet: "医疗忍者",
    count: 54,
    cover: "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20pink%20haired%20female%20ninja%20with%20green%20eyes%2C%20determined%20expression%2C%20pink%20sakura%20petals%20background%2C%20soft%20pink%20and%20white%20tones%2C%20strong%20and%20gentle%2C%20anime%20art%2C%20clean%20composition&width=520&height=520&seq=char-sakura&orientation=squarish",
    desc: "挣脱依赖、独当一面的医疗忍者与她的成长。",
  },
];

export const cpItems: CpItem[] = [
  {
    id: "cp1",
    name: "佐鸣",
    desc: "跨越恩怨的最强羁绊，人气最高CP",
    count: 230,
    tag: "羁绊",
  },
  {
    id: "cp2",
    name: "鼬佐",
    desc: "兄弟间的守护与刀尖下的温柔",
    count: 118,
    tag: "刀尖",
  },
  {
    id: "cp3",
    name: "卡卡带",
    desc: "逝去同伴与未完成的约定",
    count: 76,
    tag: "意难平",
  },
  {
    id: "cp4",
    name: "鸣樱",
    desc: "木叶的春天与笨拙的心意",
    count: 88,
    tag: "甜文",
  },
  {
    id: "cp5",
    name: "佐樱",
    desc: "沉默的守护与等候的温情",
    count: 92,
    tag: "细水长流",
  },
  {
    id: "cp6",
    name: "鹿雏",
    desc: "智力与温柔的低调日常",
    count: 47,
    tag: "日常",
  },
];

export const genres: GenreItem[] = [
  { id: "g1", name: "长篇正剧", count: 96, desc: "伏笔绵长、世界观完整的大长篇" },
  { id: "g2", name: "甜文HE", count: 142, desc: "轻松治愈、圆满结局的暖心故事" },
  { id: "g3", name: "刀尖BE", count: 78, desc: "意难平与催泪的虐心名篇" },
  { id: "g4", name: "战斗热血", count: 110, desc: "忍术对决与热血成长主线" },
  { id: "g5", name: "日常治愈", count: 130, desc: "木叶村平凡的温馨生活" },
  { id: "g6", name: "悬疑反转", count: 34, desc: "智斗与真相层层揭开" },
];

export const latestList: LatestItem[] = [
  { id: "l1", title: "《第七班的日常》第47话", category: "日常治愈", author: "木叶的青鸟", date: "2026-08-18", heat: 6200, tag: "连载中" },
  { id: "l2", title: "《雨夜的约定》新篇", category: "CP专题", author: "晓的旗帜", date: "2026-08-17", heat: 5100, tag: "最新" },
  { id: "l3", title: "《写轮眼之忆》番外", category: "深情羁绊", author: "彼岸之花", date: "2026-08-16", heat: 4700, tag: "番外" },
  { id: "l4", title: "《木叶小吃街》合集更新", category: "日常治愈", author: "丸子的忍具店", date: "2026-08-15", heat: 3900, tag: "合集" },
  { id: "l5", title: "《千本樱落》上卷", category: "甜文HE", author: "春野的花信", date: "2026-08-14", heat: 4400, tag: "新作" },
  { id: "l6", title: "《面具之下的卡卡西》", category: "角色合集", author: "寒刃", date: "2026-08-13", heat: 3600, tag: "精选" },
];

export const faqs: FaqItem[] = [
  {
    q: "这个网站收录哪些火影忍者同人作品？",
    a: "本站收录来自各大同人平台的优质火影忍者同人作品，涵盖长篇正剧、甜文HE、刀尖BE、战斗热血、日常治愈与悬疑反转等题材，并按照角色、CP、题材分类整理，方便你快速定位感兴趣的内容。",
  },
  {
    q: "如何按角色或CP快速查找同人？",
    a: "你可以通过顶部导航进入“角色合集”或“CP专题”板块，点击对应角色或CP卡片即可查看围绕该主题整理的推荐作品列表；也可以直接使用首屏的搜索框按作品名、作者或关键词检索。",
  },
  {
    q: "站内推荐的作品会持续更新吗？",
    a: "会的。我们会持续跟踪各平台的优质同人动态，定期整理“热门推荐”与“最新更新”栏目，确保你看到的目录始终贴近当前的人气风向与最新连载。",
  },
  {
    q: "同人作品版权归谁所有？",
    a: "本站仅做同人作品的整理与导航，所有作品的著作权归原作者所有，原作角色与世界观版权归原版权方所有。本站不提供任何作品下载，仅作为索引目录使用。",
  },
  {
    q: "能否投稿推荐自己的同人作品？",
    a: "当然可以。欢迎通过页面底部的联系方式向我们提交作品信息，经审核后我们会将其整理进合适的角色、CP或题材分类中，帮助更多读者发现你的创作。",
  },
];

export const stats = [
  { value: "680+", label: "收录作品" },
  { value: "24", label: "角色专题" },
  { value: "36", label: "CP分类" },
  { value: "120K+", label: "月访问" },
];